export default {
  "menu.login": "登录",
  "menu.overview": "俯瞰",
  "menu.calendar": "日历",
  "menu.projects": "项目管理",
  "menu.quality": "质量管理",
  "menu.resources": "成员视图",
  "menu.mindmaps": "思维导图",
  "menu.customers": "客户 / 产品",
  "menu.holidays": "节假日",
  "menu.notifications": "通知",
  "menu.settings": "设置",
  "menu.account.logout": "退出登录",
};
